import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='social-media'>
        <div className='social-media-wrap'>
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
              boomchrpaige
            </Link>
          </div>
          <small className='website-rights'>©{new Date().getFullYear()} Audiocomm International, BMI</small>
          <div className='social-icons'>
            <a
              className='social-icon-link facebook'
              href='https://www.facebook.com/seriousboom'
              target='_blank'
              rel='noreferrer'
              aria-label='Facebook'
            >
              <i className='fab fa-facebook-f' />
            </a>
            <a
              className='social-icon-link instagram'
              href='https://www.instagram.com/boomchrpaige/'
              target='_blank'
              rel='noreferrer'
              aria-label='Instagram'
            >
              <i className='fab fa-instagram' />
            </a>
            <a
              className='social-icon-link youtube'
              href='https://www.youtube.com/c/SeriousBoom'
              target='_blank'
              rel='noreferrer'
              aria-label='Youtube'
            >
              <i className='fab fa-youtube' />
            </a>
            <a
              className='social-icon-link soundcloud'
              href='https://soundcloud.com/boomchrpaige'
              target='_blank'
              rel='noreferrer'
              aria-label='SoundCloud'
            >
              <i className='fab fa-soundcloud' />
            </a>
            <a
              className='social-icon-link bandcamp'
              href='https://boomchrpaige.bandcamp.com'
              target='_blank'
              rel='noreferrer'
              aria-label='Bandcamp'
            >
              <i className='fab fa-bandcamp' />
            </a>      
            <a
              className='social-icon-link applemusic'
              href='https://music.apple.com/us/artist/boom-chr-paige/80850403'
              target='_blank'
              rel='noreferrer'
              aria-label='Apple Music'
            >
              <i className='fab fa-apple' />
            </a>            
            <a
              className='social-icon-link spotify'
              href='https://open.spotify.com/artist/46GltPuUxikh6VuxhJSB1Z'
              target='_blank'
              rel='noreferrer'
              aria-label='Spotify'
            >
              <i className='fab fa-spotify' />
            </a>       
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
